import axios from './aixos';
import serviceConfig from "@core/services/serviceConfig";
import { getToken } from "@core/auth/utils";
import { checkStatusCode } from "./services";

const queryString = require('query-string');
const svConfig = { ...serviceConfig };

/**
 * กำหนด timeout ต่อเส้นทาง/กลุ่มเส้นทาง
 * หน่วย: ms
 */
const PATH_TIMEOUT = [
  // ดีฟอลต์: 10 นาที
  { test: _ => true, timeout: 600000 },
];

function pickTimeout(path, dataJson) {
  // ✅ ถ้า dataJson === "timeout" → บังคับ 2 นาที
  if (dataJson === "timeout") {
    return 100000;
  }

  const rule = PATH_TIMEOUT.find(r => r.test(path));
  return rule?.timeout ?? 300000;
}

/**
 * apiServices
 * - ไม่แก้ axios.defaults.timeout (กันผลกระทบ global)
 * - รองรับ GET: ใช้ params แทน data
 * - รองรับ file: ปล่อย Content-Type ให้ axios ถ้าเป็น FormData
 * - รองรับ timeout ต่อเส้นทาง
 * - แยก code เฉพาะ timeout (ECONNABORTED) = 102
 */
const apiServices = async (dataJson, method, path, version = "", contentType = "") => {
  if (!navigator.onLine) {
    return { code: 101, result: null };
  }

  try {
    const methodType = (method === "file" ? "post" : method)?.toLowerCase();

    // ตัดสินใจ timeout ต่อเส้น
    const timeout = pickTimeout(path, dataJson);

    // เตรียม headers พื้นฐาน
    const headers = {
      "Content-Type": contentType || svConfig.contentType,
    };

    const token = getToken?.();
    if (token) {
      headers["Authorization"] = `${svConfig.headerType} ${token}`;
    }

    // จัดรูปแบบ body/params ตามชนิดคำขอและ contentType
    let config = {
      method: methodType,
      url: `${version}${path}`,
      headers,
      timeout, // ← timeout เฉพาะ request นี้
    };

    // ถ้าเป็น file upload และ dataJson เป็น FormData → ปล่อย Content-Type ให้ axios ใส่เอง
    const isFormData = (method === "file") && (typeof FormData !== 'undefined') && (dataJson instanceof FormData);
    if (isFormData && headers["Content-Type"]) {
      delete config.headers["Content-Type"];
    }

    if (methodType === "get") {
      config.params = dataJson;
      delete config.data;
    } else {
      if (isFormData) {
        config.data = dataJson;
      } else if (contentType) {
        config.data = dataJson;
      } else {
        config.data = queryString.stringify(dataJson || {});
      }
    }

    const dataPromise = await axios(config)
      .then((response) => response?.data)
      .catch((e) => {
        if (e?.response?.data) return e.response.data;
        throw e;
      });

    if (dataPromise !== undefined) {
      if (checkStatusCode(dataPromise?.code)) {
        return dataPromise;
      }
      return { code: 99, result: null };
    }

    return { code: 99, result: null };

  } catch (error) {
    if (error?.code === 'ECONNABORTED') {
      return { code: 102, result: null };
    }
    if (error?.message === 'No internet connection' || !navigator.onLine) {
      return { code: 101, result: null };
    }
    return { code: 99, result: null };
  }
};

const trackCustomerOnline = async () => {
  let config = {
    method: svConfig.method_get,
    url: `/general/toc`,
    withCredentials: true,
    headers: {
      "Authorization": `${svConfig.headerType} ${getToken()}`,
      "Content-Type": svConfig.contentType
    },
    data: {}
  };

  await axios(config).then((response) => response.data);
  return
}

const trackPlayer = async (payload) => {
  let config = {
    method: svConfig.method_post,
    url: `/general/track-player`,
    withCredentials: true,
    headers: {
      "Authorization": `${svConfig.headerType} ${getToken()}`,
      "Content-Type": svConfig.contentType
    },
    data: queryString.stringify(payload)
  };

  await axios(config).then((response) => response.data);
  return
}


export {
  apiServices,
  trackCustomerOnline,
  trackPlayer
};